import _ from 'ckLodash';
import bi from 'utils/biUtils';
import selectionUtils from 'utils/selectionUtils';

function ClassCommand(elemType, classes, commandName, childRule) {
    this.elemType = elemType;
    this.classes = classes;
    this.childRule = childRule;
    this.commandName = commandName;
}

function getFirstClass(element, classes) {
    return _.find(classes, function (className) {
        return element.hasClass(className);
    });
}

function findMatchingElements(elementPath, elemType, classes) {
    return _.filter(elementPath.elements, function (element) {
        return element.getName() === elemType && getFirstClass(element, classes);
    });
}

function createStyle(elemType, classValue, childRule) {
    return new CKEDITOR.style({
        element: elemType,
        attributes: {
            class: classValue
        },
        childRule: childRule
    });
}

function getUsedClassesInSelection(editor, classes) {
    var usedClasses = {};

    selectionUtils.forEachSelectedElement(editor, function (element) {
        var classValue = element.getAttribute && element.getAttribute('class');
        if (!classValue) {
            return;
        }

        _.forEach(classes, function (cls) {
            if (classValue.indexOf(cls) >= 0) {
                //the class (cls) is used in the class attribute value
                usedClasses[cls] = true;
            }
        });
    });

    return _.keys(usedClasses);
}

function removeClasses(editor, classesToRemove, elementType) {
    _.forEach(classesToRemove, function (cls) {
        editor.removeStyle(createStyle(elementType, cls));
    });
}

function removeUsedClassesInSelection(editor) {
    var usedClasses = getUsedClassesInSelection(editor, this.classes);

    //add current class if there is one for when selection in the same text node
    //Example selection - <span class="color_3">text{sd}sdfsd</span>
    if (this.state !== CKEDITOR.TRISTATE_OFF && !_.includes(usedClasses, this.state)) {
        usedClasses.push(this.state);
    }

    removeClasses(editor, usedClasses, this.elemType);
}

ClassCommand.prototype = {
    contextSensitive: true, //Config CK to call refresh the command after selection change
    exec: function (editor, paramValue) {
        removeUsedClassesInSelection.call(this, editor);

        if (paramValue !== CKEDITOR.TRISTATE_OFF && _.includes(this.classes, paramValue)) {
            editor.applyStyle(createStyle(this.elemType, paramValue, this.childRule));
        }
    },
    refresh: function (editor, elementPath) {
        var state,
            stylesElements = findMatchingElements(elementPath, this.elemType, this.classes);

        if (stylesElements.length === 0) {
            state = CKEDITOR.TRISTATE_OFF;
        } else {
            if (stylesElements.length > 1) {
                bi.error.nestedStyles(this.commandName);
            }

            state = getFirstClass(stylesElements[0], this.classes);
        }
        this.setState(state);
    }
};

export default ClassCommand;
